export enum EUserProfileActionType {
    removeProfile = 'REMOVE_PROFILE',
    saveProfile = 'SAVE_PROFILE',
    updateTosStatus = 'UPDATE_TOS_STATUS',
}
